module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "blog"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "main_description a_center"
  }, [_vm._v("Entérate de las útlimas novedades y eventos que tenemos para ti.")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('item-blog'), _vm._v(" "), _c('item-blog'), _vm._v(" "), _c('item-blog'), _vm._v(" "), _c('item-blog')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main_title mt_wave a_center"
  }, [_c('h2', [_vm._v("ÚLTIMAS NOTICIAS")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a3849b1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/blog/Blog.vue
// module id = 378
// module chunks = 0